import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import { selectRoles } from "../../reduxStore/RolesReducer";

export default function Title({ createFunction, openFilterColumn }) {
    const [t] = useTranslation("common");
    const maintheme = useSelector((state) => state.themeData.maintheme);
    const rolesRedux = useSelector(selectRoles);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between !important",
                width: "100%",
                marginBottom: "10px",
            }}
            className="page-header-style"
        >
            <Typography
                sx={{
                    fontFamily: "Cairo-Bold",
                    fontSize: "20px",
                    color: maintheme?.primary,
                }}
            >
                {t("ACCOUNTS.title") || "بيانات الحسابات"}
            </Typography>
            {rolesRedux?.add_accounts?.value || rolesRedux?.add_master?.value ? (
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={createFunction}
                    sx={{
                        fontFamily: "Cairo-Medium",
                        backgroundColor: maintheme?.primary,
                        "&:hover": {
                            backgroundColor: maintheme?.secondary,
                        },
                    }}
                >
                    {t("GLOBAL.action_add") || "إضافة"}
                </Button>
            ) : null}
        </Box>
    );
}
